import React from 'react'
import { AmpIFrame } from '../../../publication/Embed/amp/AmpIFrame'
import { StyledContent } from '../../../publication/Embed/amp/AmpStyledContent.styled'

export interface AmpWayInProps {
    height: number
    width: number
    link: string
    resizable: boolean
}

export const AmpWayIn: React.FunctionComponent<AmpWayInProps> = (props) => (
    <StyledContent>
        <AmpIFrame
            height={props.height}
            width={props.width}
            layout="responsive"
            allowSameOrigin={true}
            allowPopups={true}
            allowForms={true}
            src={props.link}
            resizable={props.resizable}
        />
    </StyledContent>
)
